module.exports = __webpack_public_path__ + "img/83.d4d9579c.jpg";